import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver, Injectable,
  Injector, Input, OnChanges,
  OnDestroy,
  OnInit, SimpleChanges,
  ViewChild
} from '@angular/core';
import {PlaylistService} from '../../../services/playlist/playlist.service';
import {RewardService} from '../../../services/reward/reward.service';
import {MuscleDataService} from '../../../services/muscle-data.service';
import {CdkPortal, DomPortalHost} from '@angular/cdk/portal';
import {Subject, Subscription} from 'rxjs';
import {FirebaseService} from '../../../services/firebase/firebase.service';
import {EmailTemplatesService} from '../../../services/email-templates/email-templates.service';
import {TrainingScreenComponent} from '../training-screen/training-screen.component';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../../core/reducers';
import {currentUser} from '../../../core/auth';
import { distinctUntilChanged, take, takeUntil} from 'rxjs/operators';
import {TrainingTemplateDataService} from '../../../services/training-template-data/training-template-data.service';
import {EmailDateService} from '../../../services/email-date/email-date.service';
import {VideoService} from '../../../services/video-service/video.service';
import {AngularFireStorage} from '@angular/fire/storage';
import {VideoTimeService} from '../../../services/video-time/video-time.service';
import * as moment from 'moment';
import {
  AddYoutubePlaylistComponent
} from '../training-configuration/add-youtube-playlist/add-youtube-playlist.component';
import {MatDialog} from '@angular/material/dialog';
import {ChangeVideoPauseService} from '../../../services/change-video-pause/change-video-pause.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TranslationService} from '../../../core/_base/layout';
import {TenantService} from '../../../core/tenant/tenant.service';

@Component({
  selector: 'kt-youtube-video',
  templateUrl: './youtube-video.component.html',
  styleUrls: ['./youtube-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeVideoComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @ViewChild(CdkPortal) portal: CdkPortal;
  @Input() sessionTime;
  private externalWindow = null;
  public videoId = '1SLr62VBBjw';
  public player;
  options = {
    cc_lang_pref: 'en',
    controls: 0,
    autoplay: 0,
    rel: 0,
  };
  playlistUrl = '';
  videosArray = [];
  videoMuted = false;
  videoVolume = 50;
  showVolumeMenu = false;
  artefaktValue: number;
  carouselHeight = 150;
  host;
  playVideoSubscription: Subscription;
  videoTimeTrackerInterval: any;
  useBlackOverlay = false;
  youtubeFreezeTime = 0;
  youtubeHeld = false;
  youtubeCover = false;
  youtubeLastState = -1;
  youtubeLastStartAt = 0;
  youtubeRevealTimer: any;
  currentVideoId;
  trainerUser;
  deleteTrainerSubscription: Subscription;
  currentUserId = '';
  showOptions = false;
  showVideo = true;
  currentUser;

  germanDeleteSupervisor;
  englishDeleteSupervisor;
  public videoType = 'youtube';
  videoPlayer = null;
  previousTemplate = null;
  currentTemplateSubscription: Subscription;
  customVideoVolume = 50;
  muteCustomVideo = false;
  userVideoTimings = [];

  showSeekHint = false;
  youtubeSeekValue: number;
  youtubeSeekVideoIndex: number;
  customVideoSeekValue: number;
  clearYoutubeVideoSubscription: Subscription;
  hintSeconds: number;

  dbVideoTimingUpdated = false;
  videoTimeBeforeHide: number;
  customVideoTimeBeforeHide: number;
  customVideoLastUrl;
  trainingTemplate = null;
  videoIndex = 0;
  currentYoutubeTime = null;
  currentCustomVideoTime = null;
  maxYoutubeTime = null;
  maxCustomVideoTime = null;
  paybackRates = [0.5, 1, 1.5, 2];
  videoChangedByUser = new Subject();
  youtubeVideoSubscription: Subscription;
  customVideoSubscription: Subscription;
  trainingTime = 0;
  paybackRate = 1;
  feedBackType = 'startStop';
  isTabletIos = false;
  continueVideoForNextPart = false;

  constructor(
    private playlist: PlaylistService,
    private reward: RewardService,
    private cd: ChangeDetectorRef,
    private muscleData: MuscleDataService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private firebase: FirebaseService,
    private emailTemplates: EmailTemplatesService,
    private trainingScreen: TrainingScreenComponent,
    private store: Store<AppState>,
    private trainingData: TrainingTemplateDataService,
    private emailDate: EmailDateService,
    private video: VideoService,
    private afstorage: AngularFireStorage,
    private videoTime: VideoTimeService,
    private dialog: MatDialog,
    private pauseByChange : ChangeVideoPauseService,
    private detector: DeviceDetectorService,
    private translates: TranslationService,
    public tenant: TenantService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.trainingTime = changes.sessionTime.currentValue;
  }
  ngOnInit(): void {
    this.subscribeOnTrainerUser();
    this.getUserId();
    this.subscribeOnYoutubeUrl();
    this.subscribeOnCustomVideoUrl();
    this.handleYoutubeStop();
  }

  ngAfterViewInit(): void {
    this.initPlayer();
    this.initPlaylist();
    this.subscribeToArtefaktSignal();
    this.getScreenWidth();
    this.playVideoCondition();
    this.trackVideoTime();
    setTimeout(() => {
      this.subscribeOnScreenOptions();
    },2000);
    this.getEmailTemplates();
    this.subscribeOnCurrentTemplate();
  }

  handleYoutubeStop() {
    this.clearYoutubeVideoSubscription = this.videoTime.clearYoutubeSeekTime.subscribe((value) => {
      if (value) {
        this.clearPlayerTime();
      }
    });
  }

  getUserId() {
    this.store.pipe(select(currentUser)).subscribe(user => {
      if(user) {
        this.currentUser = user;
        this.currentUserId = user.id;
        this.getUserVideoTiming();
      }
    });
  }

  getUserVideoTiming() {
    this.firebase.getVideoTimingData(this.currentUserId).subscribe((timings:any) => {
      this.dbVideoTimingUpdated = true;
      this.userVideoTimings = [];
      timings.forEach((el) => {
        if (el.name.includes('/')) {
          el.name = el.name.split('/')[0];
        }
        el.data.forEach((timing) => {
          this.userVideoTimings.push(timing);
        })
      });
    });
  }

  getEmailTemplates() {
    this.emailTemplates.getTemplate('supervisorDeletedDE').pipe(take(1)).subscribe((template: any) => {
      this.germanDeleteSupervisor = template;
    });
    this.emailTemplates.getTemplate('supervisorDeleted').pipe(take(1)).subscribe((template: any) => {
      this.englishDeleteSupervisor = template;
    });
  }

  subscribeOnCurrentTemplate() {
    this.currentTemplateSubscription = this.trainingData.currentTemplate.pipe(distinctUntilChanged()).subscribe((template:any) => {
      if (template && template.continueVideoForNextPart && (template.youtubePlaylistUrl || template.customVideoUrl)) {
        this.continueVideoForNextPart = true;
        this.trainingTemplate = template;
      }
      if (template && (template.youtubePlaylistUrl || template.customVideoUrl)) {
        this.trainingTemplate = template;
        this.checkVideoTiming(template);
      } else if (template) {
        this.trainingTemplate  = template;
      }
      if (template) {
        if (!template.youtubePlaylistUrl && !template.customVideoUrl) {
          if (this.continueVideoForNextPart) {
            return;
          }
          this.trainingData.youtubePlaylistSubject.next(null);
          this.videoType = 'youtube';
          this.videoId = this.translates.getSelectedLanguage() === 'en' ? 'hTfue5D3gNY' : 'czylygDwK0U';
          this.setVideo(this.videoId);
        }
      }
    });
  }
  checkVideoTiming(template) {
    const foundedTiming = this.userVideoTimings.find(element => element.youtubePlaylistUrl === template.youtubePlaylistUrl);
    const foundedTimingCustomVideo = this.userVideoTimings.find(element => element.customVideoUrl === template.customVideoUrl);
    if (foundedTiming && this.videoType === 'youtube' && foundedTiming.youtubePlaylistUrl) {
      this.youtubeSeekValue = foundedTiming.videoConfig.time;
      if (foundedTiming.videoConfig && foundedTiming.videoConfig.videoIndex !== 0) {
        this.youtubeSeekVideoIndex = foundedTiming.videoConfig.videoIndex;
      }
      this.showSeekHint = true;
      this.dbVideoTimingUpdated = false;
      this.hintSeconds = foundedTiming.videoConfig.time;
    }
    if (foundedTimingCustomVideo && this.videoType === 'custom' && foundedTimingCustomVideo.customVideoUrl) {
      this.customVideoSeekValue = foundedTimingCustomVideo.videoConfig.time;
      this.showSeekHint = true;
      this.dbVideoTimingUpdated = false;
      this.hintSeconds = foundedTimingCustomVideo.videoConfig.time;
    }
    this.triggerVideoHide(this.trainingTemplate.showVideo);
    this.changeFeedbackType(this.trainingTemplate.feedBackType);
  }

  transformSeconds(seconds) {
    return moment.utc(seconds * 1000).format('HH:mm:ss');
  }

  clearPlayerTime() {
    if (this.player && this.videoType === 'youtube') {
      this.videoIndex = 0;
      this.player.seekTo(0);
      this.videoPlayer = null;
    } else if (this.videoPlayer && this.videoType === 'custom') {
      this.video.setVideoTime(this.videoPlayer, 0);
      this.player = null;
    }
    this.showSeekHint = false;
  }

  setVideoTime() {
    if (this.youtubeSeekValue > 1 && this.videoType === 'youtube') {
      // if (this.youtubeSeekVideoIndex) {
      //   this.videoIndex = this.youtubeSeekVideoIndex
      //   this.videoId = this.videosArray[this.youtubeSeekVideoIndex].id;
      //   this.setVideo(this.videoId);
      // }
      this.player.seekTo(this.youtubeSeekValue);
      this.videoPlayer = null;
      this.showSeekHint = false;
    } else if (this.customVideoSeekValue > 1 && this.videoType === 'custom') {
      this.video.setVideoTime(this.videoPlayer, this.customVideoSeekValue);
      this.player = null;
      this.showSeekHint = false;
    }
  }

  closeYoutubeHint() {
    this.showSeekHint = false;
  }

  subscribeOnCustomVideoUrl() {
    this.customVideoSubscription = this.trainingData.customVideoSubject.pipe(takeUntil(this.videoChangedByUser)).pipe(distinctUntilChanged()).subscribe((url) => {
      if (url) {
        this.videoType = 'custom';
        const ref = this.afstorage.ref(url);
        const downloadUrl = ref.getDownloadURL();
        downloadUrl.subscribe((videoUrl) => {
          const timeout = setTimeout(() => {
            if (this.customVideoLastUrl !== videoUrl) {
              this.createVideoPlayer(videoUrl);
            }
            this.customVideoLastUrl = videoUrl;
            clearTimeout(timeout);
          },1500)
        })
      }
    });
  }

  subscribeOnYoutubeUrl() {
    this.youtubeVideoSubscription = this.trainingData.youtubePlaylistSubject.pipe(takeUntil(this.videoChangedByUser)).subscribe((url) => {
      if (url) {
        this.videoType = 'youtube';
        if (url.includes('PL')) {
          this.playlistUrl = url;
          this.initPlayer();
          this.initPlaylist();
          this.cd.markForCheck();
        } else {
          this.videoId = url;
          this.setVideo(url);
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.playVideoSubscription) {
      this.playVideoSubscription.unsubscribe();
    }
    if (this.videoTimeTrackerInterval) {
      clearInterval(this.videoTimeTrackerInterval);
    }
    clearTimeout(this.youtubeRevealTimer);
    this.playlistUrl = '';
    if (this.currentTemplateSubscription) {
      this.currentTemplateSubscription.unsubscribe();
    }
    if (this.clearYoutubeVideoSubscription) {
      this.clearYoutubeVideoSubscription.unsubscribe();
    }
    if (this.youtubeVideoSubscription) {
      this.youtubeVideoSubscription.unsubscribe();
    }
    if (this.customVideoSubscription) {
      this.customVideoSubscription.unsubscribe();
    }
    this.trainingTemplate = null;
    this.continueVideoForNextPart = false;
  }

  subscribeOnScreenOptions() {
    this.firebase.getUserScreenOptionsVideo(this.currentUser.id).subscribe((options: any) => {
      if (options) {
        this.triggerVideoHide(options.showYoutubeVideo);
        this.cd.markForCheck();
      }
    });
  }

  subscribeToArtefaktSignal() {
    this.muscleData.artefaktSubject.subscribe((value) => {
      this.artefaktValue = value;
    });
  }
  getScreenWidth() {
    if (window.innerWidth <= 1366) {
      this.carouselHeight = 50;
      this.cd.markForCheck();
    }
  }

  initPlayer() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  initPlaylist() {
    if (this.playlistUrl) {
      this.playlist.getPlayList(this.playlistUrl).subscribe((playlist: any) => {
        this.videosArray = [];
        playlist.items.forEach((item) => {
          const videoObject = {
            id: item.snippet.resourceId.videoId,
            name: item.snippet.title,
            imageUrl: item.snippet.thumbnails.medium?.url
          }
          this.videosArray.push(videoObject);
          this.videoId = playlist.items[this.videoIndex].snippet.resourceId.videoId;
        });
      });
    }
  }


  savePlayer($event) {
    if($event) {
      this.player = $event.target;
      if (this.isIosTablet()) {
        this.player.mute();
        this.videoMuted = true;
      }
      this.player.pauseVideo();
      this.setVideoVolume(this.videoVolume);
      this.player.seekTo(this.videoTimeBeforeHide);
      this.setPlayerPlaybackRate(this.trainingTemplate && this.trainingTemplate.paybackSpeed ? this.trainingTemplate.paybackSpeed : 1);
      // canPlayVideo may have already flipped to true while this player was (re)loading -
      // distinctUntilChanged() won't re-fire that transition, so resync explicitly here.
      this.applyPlayCondition(this.reward.canPlayVideo.value);
      this.cd.markForCheck();
      this.player.addEventListener('onStateChange', (event) => {
        // Tracked unconditionally (not just while useBlackOverlay is checked), so youtubeLastState/
        // youtubeLastStartAt are already accurate if the checkbox gets checked after the player is already
        // playing - otherwise the player never leaves PLAYING during a fake-pause, no future transition ever
        // sets them, and revealYoutubeVideo()'s youtubeLastState === 1 check would never pass again.
        if (event.data !== 1) {
          if (this.useBlackOverlay) {
            // Safety net: any state but PLAYING covers the frame instantly; entering PLAYING starts the ~4s icon window.
            this.youtubeCover = true;
          }
        } else if (this.youtubeLastState !== 1) {
          this.youtubeLastStartAt = performance.now();
          if (this.useBlackOverlay) {
            this.revealYoutubeVideo();
          }
        }
        this.youtubeLastState = event.data;
        this.cd.markForCheck();
        if (event.data === 0) {
          this.videoIndex++
          if (this.videoIndex >= this.videosArray.length) {
            this.videoIndex = 0
          }
          if (this.videosArray.length) {
            this.videoId = this.videosArray[this.videoIndex].id;
            this.setVideo(this.videoId);
          } else {
            this.seekYoutubeVideo(0);
          }
        }
        if (this.useBlackOverlay && event.data === 2) {
          // We never pause on purpose when faking it, so YouTube paused by itself: resume (the cover is already up).
          this.player.playVideo();
        }
        if (event.data === 5) {
          this.applyPlayCondition(this.reward.canPlayVideo.value);
        }
      });
    }
  }

  setVideo(videoLink: string, index?) {
    if (this.continueVideoForNextPart) {
      return;
    }
    this.currentVideoId = videoLink;
    if (this.player && videoLink) {
      this.resetYoutubeHold();
      this.setPlayerPlaybackRate(this.paybackRate);
      this.player.setPlaybackQuality('hd720');
      this.player.loadVideoById(`${videoLink}`);
      this.player.stopVideo();
    }
    if (index) {
      this.videoIndex = index;
    }
  }

  createVideoPlayer(url) {
    const isIosTablet = this.isIosTablet();
    this.videoPlayer = document.getElementById('video-player');
    if (isIosTablet) {
      this.muteCustomVideo = true;
    }
    if (this.videoPlayer) {
      this.video.setVideo(this.videoPlayer, url, isIosTablet);
      this.video.setVideoVolume(this.videoPlayer, this.customVideoVolume);
      this.setPlayerPlaybackRate(this.trainingTemplate && this.trainingTemplate.paybackSpeed ? this.trainingTemplate.paybackSpeed : 1);
      this.videoPlayer.addEventListener('loadedmetadata', () => {
        this.maxCustomVideoTime = this.videoPlayer.duration;
      });
      this.applyPlayCondition(this.reward.canPlayVideo.value);
    }
  }

  playVideoCondition() {
    this.playVideoSubscription = this.reward.canPlayVideo.pipe(distinctUntilChanged()).subscribe((canPlay) => {
      this.applyPlayCondition(canPlay);
    });
  }

  applyPlayCondition(canPlay: boolean) {
    if (this.videoType === 'youtube') {
      if(canPlay && this.player) {
        if (this.useBlackOverlay) {
          this.unfreezeYoutubeVideo();
        } else {
          this.player.playVideo();
        }
        this.setPlayerPlaybackRate(this.paybackRate);
      } else if (!canPlay && this.showVideo && this.player) {
        if (this.feedBackType === 'startStop') {
          this.useBlackOverlay ? this.freezeYoutubeVideo() : this.player.pauseVideo();
        } else {
          if (this.artefaktValue > 6 || this.muscleData.currentImpedance > 20) {
            this.useBlackOverlay ? this.freezeYoutubeVideo() : this.player.pauseVideo();
          } else {
            this.setPlayerPlaybackRate(0.5);
          }
        }
      }
    }
    if (this.videoType === 'custom') {
      if (canPlay && this.showVideo && this.videoPlayer) {
        this.video.playVideo(this.videoPlayer);
        this.setPlayerPlaybackRate(this.paybackRate);
      } else if (!canPlay && this.showVideo) {
        if (this.feedBackType === 'startStop') {
          this.video.pauseVideo(this.videoPlayer);
        } else {
          if (this.artefaktValue > 6 || this.muscleData.currentImpedance > 20) {
            this.video.pauseVideo(this.videoPlayer);
          } else {
            this.setPlayerPlaybackRate(0.5);
          }
        }
      }
    }
  }
  handleYoutubeVideoTime() {
    if (this.videoId && this.player) {
      this.currentYoutubeTime = this.getYoutubeTime();
      this.maxYoutubeTime = this.player.getDuration();
      this.cd.markForCheck();
    }
  }
  trackVideoTime() {
    this.videoTimeTrackerInterval = setInterval(() => {
      if (this.videoType === 'youtube' && this.player) {
        this.handleYoutubeVideoTime();
        this.videoTime.setVideoConfig(this.getYoutubeTime(), this.videoType, this.videoIndex);
      } else if (this.videoType === 'custom' && this.videoPlayer) {
        this.currentCustomVideoTime = this.videoPlayer.currentTime;
        this.videoTime.setVideoConfig(this.videoPlayer.currentTime, this.videoType);
      }
    }, 500);
  }
  youtubeVideoTiming(value) {
    if(value) {
      return moment.utc(value * 1000).format('HH:mm:ss');
    }
  }
  setPlayerPlaybackRate(rate, byUserClick?) {
    if (byUserClick) {
      this.paybackRate = rate;
    }
    if (this.videoType === 'youtube' && this.player) {
      this.player.setPlaybackRate(rate);
    } else {
      this.video.setVideoPaybackRate(this.videoPlayer ,rate)
    }
  }

  changeFeedbackType(type) {
    this.paybackRate = 1;
    this.feedBackType = type;
  }

  seekYoutubeVideo(value) {
    this.player.seekTo(value);
  }

  // Faked pause: the player is never really paused, so it stays in PLAYING and YouTube never draws its
  // play/pause icon. Cover the frame instantly, mute and run at the slowest rate (0.25). Only used when
  // useBlackOverlay is checked in the volume menu; otherwise applyPlayCondition calls pauseVideo() directly.
  freezeYoutubeVideo() {
    if (!this.player || this.youtubeHeld) return;
    this.youtubeHeld = true;
    this.youtubeFreezeTime = this.player.getCurrentTime();
    this.youtubeCover = true;
    this.player.setVolume(0);
    this.player.setPlaybackRate(0.25);
    this.cd.markForCheck();
  }

  unfreezeYoutubeVideo() {
    if (!this.player) return;
    this.youtubeHeld = false;
    this.player.setPlaybackRate(this.paybackRate);
    this.player.setVolume(this.videoVolume);
    this.player.playVideo();
    this.revealYoutubeVideo();
  }

  // The icon stays visible ~4s after the player enters PLAYING, so the cover only lifts when the player is
  // playing, not held, and 4500ms have passed since it started playing; otherwise it reschedules itself.
  revealYoutubeVideo() {
    clearTimeout(this.youtubeRevealTimer);
    if (this.youtubeHeld) return;
    const wait = 4500 - (performance.now() - this.youtubeLastStartAt);
    if (this.youtubeLastState === 1 && wait <= 0) {
      this.youtubeCover = false;
      this.cd.markForCheck();
      return;
    }
    this.youtubeRevealTimer = setTimeout(() => this.revealYoutubeVideo(), this.youtubeLastState === 1 ? wait : 200);
  }

  // While held, report the time the hold started, not the hidden, still-advancing time. A no-op (always
  // returns the real time) when useBlackOverlay is off, since youtubeHeld never becomes true then.
  getYoutubeTime() {
    return this.youtubeHeld ? this.youtubeFreezeTime : this.player.getCurrentTime();
  }

  resetYoutubeHold() {
    clearTimeout(this.youtubeRevealTimer);
    this.youtubeHeld = false;
    this.youtubeLastState = -1;
    this.youtubeCover = this.useBlackOverlay;
  }

  seekCustomVideo(value) {
    this.video.setVideoTime(this.videoPlayer, value)
  }

  setVideoVolume(event) {
    this.videoVolume = event;
    this.player.setVolume(event);
  }

  setCustomVideoVolume(event) {
    this.customVideoVolume = event;
    this.video.setVideoVolume(this.videoPlayer, this.customVideoVolume);
  }

  nextYoutubeVideo() {
    this.videoIndex++
    if (this.videoIndex >= this.videosArray.length) {
      this.videoIndex = 0
    }
    this.videoId = this.videosArray[this.videoIndex].id;
    this.setVideo(this.videoId);
  }

  previousYoutubeVideo() {
    this.videoIndex--;
    if (this.videoIndex < this.videosArray.length) {
      this.videoIndex = 0
    }
    this.videoId = this.videosArray[this.videoIndex].id;
    this.setVideo(this.videoId);
  }

  setVideoVolumeWindow(event) {
    this.videoVolume = +event.target.value;
    this.player.setVolume(+event.target.value);
  }

  toggleVolumeMenu() {
    this.showVolumeMenu = !this.showVolumeMenu;
    this.cd.markForCheck();
  }

  get currentVolume() {
    return this.videoType === 'youtube' ? this.videoVolume : this.customVideoVolume;
  }

  setVolume(value) {
    if (this.videoType === 'youtube') {
      this.setVideoVolume(value);
    } else {
      this.setCustomVideoVolume(value);
    }
  }

  muteVideo() {
    if (this.videoType === 'youtube') {
      this.videoMuted = !this.videoMuted;
      if (this.videoMuted) {
        this.player.mute();
      } else if (!this.videoMuted) {
        this.player.unMute();
        this.setVideoVolume(this.videoVolume);
      }
    } else {
      this.muteCustomVideo = !this.muteCustomVideo;
      this.video.muteVideo(this.videoPlayer, this.muteCustomVideo);
    }
  }

  subscribeOnTrainerUser() {
    this.reward.trainer.subscribe((trainer:any) => {
      this.trainerUser = trainer;
      this.cd.markForCheck();
      if (trainer) {
        this.getTrainerPlaylist(trainer.id)
      }
    })
  }

  getTrainerPlaylist(trainerId) {
    this.firebase.getTrainerOptions(trainerId, 'Training').pipe(take(1)).subscribe((options:any) => {
      options = options[0];
      if (!options) {
        return;
      }
      if (options.youtubePlaylist) {
        this.videoType = 'youtube';
        this.playlistUrl = options.youtubePlaylist;
        this.initPlayer();
        this.initPlaylist();
        this.cd.markForCheck();
        if (this.videosArray.length) {
          setTimeout(() => {
            this.setVideo(this.videosArray[0].id);
            this.videoId = this.videosArray[0].id;
            this.cd.markForCheck();
          }, 2000)
        }
      }
      if (options.customVideoUrl) {
        this.videoType = 'custom';
        const ref = this.afstorage.ref(options.customVideoUrl);
        const downloadUrl = ref.getDownloadURL();
        downloadUrl.subscribe((videoUrl) => {
          const timeout = setTimeout(() => {
            if (this.customVideoLastUrl !== videoUrl) {
              this.createVideoPlayer(videoUrl);
            }
            this.customVideoLastUrl = videoUrl;
            clearTimeout(timeout);
          },1500)
        });
      }
    });
  }

  deleteTrainer() {
    this.deleteTrainerSubscription = this.firebase.getUidByUserId(this.trainerUser.id).pipe(take(1)).subscribe((trainer:any) => {
      if (trainer.length) {
        this.trainingScreen.showOptions = true;
        this.trainingScreen.trainerId = null;
        const updatedUser = Object.assign({}, this.currentUser);
        updatedUser.trainerId = '';
        this.firebase.updateUser(this.currentUser.uid, updatedUser);
        this.firebase.deleteTrainer(trainer[0].id, 'Training', this.currentUserId);
        this.deleteTrainerSubscription.unsubscribe();
        this.reward.trainer.next(null);
        if (this.trainingScreen.getUserSubscription) {
          this.trainingScreen.getUserSubscription.unsubscribe();
        }
      }
    });
  }

  transformDate(date) {
    if (date) {
      const time = new Date(date);
      const trainingDay = time.toLocaleDateString();
      const hour = time.getHours();
      const minutes = time.getMinutes();
      if (minutes < 10) {
        return trainingDay + ' ' + '-' + ' ' + hour + ':' + `0${minutes}`;
      }
      return trainingDay + ' ' + '-' + ' ' + hour + ':' + minutes;
    }
  }

  triggerVideoHide(conditionByTemplate?) {
    if (conditionByTemplate !== undefined) {
      this.showVideo = conditionByTemplate;
    } else {
      this.showVideo = !this.showVideo;
    }
    if (this.showVideo && this.videoType === 'youtube') {
      if (!this.player) {
        this.initPlayer();
        this.initPlaylist();
      }
      this.cd.markForCheck();
    } else if (this.showVideo && this.videoType === 'custom') {
      const timeout = setTimeout(() => {
        this.createVideoPlayer(this.customVideoLastUrl);
        this.video.setVideoTime(this.videoPlayer, this.customVideoTimeBeforeHide);
        clearTimeout(timeout);
      },1500);
    }
    else {
      if (this.videoType === 'youtube') {
        if (this.player) {
          this.videoTimeBeforeHide = this.getYoutubeTime();
        }
        this.resetYoutubeHold();
        this.player = null;
      }
      if (this.videoType === 'custom') {
        this.customVideoTimeBeforeHide = this.videoPlayer.currentTime;
        this.videoPlayer = null;
      }
    }
    this.cd.markForCheck();
  }

  limitOfCharacters(nameLength: number): number {
    if (nameLength > 20) {
      return 15;
    }
    return 120;
  }
  changeVideoDialog() {
    this.pauseByChange.pauseSubject.next(true);
    this.dialog.open(AddYoutubePlaylistComponent, {
      disableClose: true,
      panelClass: 'dialog-scroll',
      maxWidth: '100vw',
      data: this.options
    }).afterClosed().subscribe((data) => {
      if (!data) {
        this.pauseByChange.pauseSubject.next(false);
        return;
      }
      this.videoChangedByUser.next('');
      this.videoChangedByUser.complete();
      this.dbVideoTimingUpdated = true;
      if (data.video && data.video.downloadUrl) {
        this.videoType = 'custom';
        const ref = this.afstorage.ref(data.video.downloadUrl);
        const downloadUrl = ref.getDownloadURL();
        downloadUrl.subscribe((videoUrl) => {
          const timeout = setTimeout(() => {
            this.continueVideoForNextPart = true;
            if (this.customVideoLastUrl !== videoUrl) {
              this.createVideoPlayer(videoUrl);
            }
            this.customVideoLastUrl = videoUrl;
            this.trainingData.changedCustomVideoSubject.next(videoUrl);
            this.checkVideoTiming(this.trainingTemplate);
            clearTimeout(timeout);
          },1500)
        });
        this.pauseByChange.pauseSubject.next(false);
        this.cd.markForCheck();
      } else {
        this.videoType = 'youtube';
        if (data.includes('&ab')) {
          data = data.split('&ab')[0];
        }
        if (data.includes('PL')) {
          this.continueVideoForNextPart = true;
          this.playlistUrl = data;
          this.initPlaylist();
          this.trainingData.customYouTubeVideoSubject.next(data);
          this.checkVideoTiming(this.trainingTemplate);
        } else {
          this.continueVideoForNextPart = true;
          this.videoId = data;
          this.setVideo(data);
          this.trainingData.customYouTubeVideoSubject.next(data);
          this.checkVideoTiming(this.trainingTemplate);
        }
        this.pauseByChange.pauseSubject.next(false);
        this.cd.markForCheck();
      }
    });
  }

  isIosTablet() {
    return this.detector.isTablet(this.detector.userAgent);
  }
  isEmptyVideo() {
    return !!(this.videoId === 'hTfue5D3gNY' || this.videoId === 'czylygDwK0U');
  }
}
